import React, { FC, useState } from 'react';
import { useDataProvider } from 'src/app/common/utils';
import { useDispatch } from 'react-redux';
import { useIntl } from 'react-intl';
import PruFilter, { PruFilterItemType } from 'src/app/common/components/PruTable/PruFilter';
import { ParamsProps } from 'src/app/common/components/ParamsProvider';
import { PaginateListMore } from 'src/app/common/types';
import { fetchList, ListParam } from 'src/app/modules/PulseLeads/network/autoLeadReassignmentCrud';
import RulesList from './components/RulesList';
import { RouteComponentProps } from 'react-router-dom';
import { RulesListItem, RulesStatus, RulesType } from 'src/app/modules/PulseLeads/types/auto-lead-reassignment-types';

type RulesListingPageProps = {} & ParamsProps & RouteComponentProps & {
  ruleType: RulesType;
};

const initialState: ListParam = {
  limit: 5,
  page: 1,
};

const paramsInitiator = (initialParams?: Record<string, string>): ListParam => {
  return initialParams
    ? {
      page: 1,
      limit: 5,
    }
    : initialState;
};

const RulesListingPage: FC<RulesListingPageProps> = ({ onChangeQueryParams, ruleType }) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });
  const dispatch = useDispatch();
  const [filterState, setFilterState] = useState<ListParam>(paramsInitiator());
  const [dataList, setDataList] =
    useState<PaginateListMore<RulesListItem>>();

  const { isLoading, refreshData } = useDataProvider<PaginateListMore<RulesListItem>>(
    async () => {
      try {
        if (onChangeQueryParams) {
          onChangeQueryParams(filterState);
        }
        return await fetchList(ruleType, filterState, dispatch);
      } catch (err) { }
    },
    setDataList,
    false,
  );

  return (
    <>
      <PruFilter
        title={Translation(`pulseleads.leadReassignment.filter`)}
        itemDef={[
          {
            type: PruFilterItemType.FREE_TEXT,
            field: 'ruleId',
            initialValue: filterState.ruleId,
            displayName: "Rule ID",
          },
          {
            type: PruFilterItemType.FREE_TEXT,
            field: 'campaignName',
            initialValue: filterState.campaignName,
            displayName: "Campaign Name",
          },
          {
            type: PruFilterItemType.DROPDOWN,
            field: 'status',
            displayName: 'Status',
            choices: [
              { displayName: 'All', value: '' },
              { displayName: RulesStatus.active, value: RulesStatus.active },
              { displayName: RulesStatus.stopped, value: RulesStatus.stopped }
            ],
          },
          {
            type: PruFilterItemType.DATE_RANGE,
            fieldFrom: 'publishedAtFrom',
            fieldTo: 'publishedAtTo',
            initialDateFrom: filterState.publishedAtFrom,
            initialDateTo: filterState.publishedAtTo,
            displayName: "Publish date",
          },
        ]}
        onChangeFilter={(data) =>
          setFilterState({
            ...filterState,
            ruleId: data.ruleId,
            campaignName: data.campaignName,
            status: data.status ? data.status as RulesStatus : undefined,
            publishedAtFrom: data.publishedAtFrom,
            publishedAtTo: data.publishedAtTo,
          })
        }
        fetchData={refreshData}
      />
      <RulesList
        isLoading={isLoading}
        ruleType={ruleType}
        dataList={dataList}
        onRefresh={() => {
          refreshData();
        }}
        onChangePage={(page, rowsPerPage) => {
          setFilterState({
            ...filterState,
            page,
            limit: rowsPerPage,
          });
          refreshData();
        }}
      />
    </>
  );
};

export default RulesListingPage;
